module.exports = __webpack_public_path__ + "assets/bsc-logo.c1333458.svg";